var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[(_vm.$route.name === 'home')?_c('div',{attrs:{"id":"disposables-login"}},[_c('router-view')],1):_c('div',{attrs:{"id":"disposables"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }